
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.394 3.342a.75.75 0 01.356.638v13a.75.75 0 01-.415.67l-5.986 2.994a.746.746 0 01-.698 0L9 17.818 3.335 20.65a.75.75 0 01-1.085-.67v-13a.75.75 0 01.415-.671L8.65 3.315a.747.747 0 01.698 0L15 6.141l5.665-2.832a.75.75 0 01.73.033zM15.75 18.766l4.5-2.25V5.193l-4.5 2.25v11.323zm-1.5-11.323v11.323l-4.5-2.25V5.193l4.5 2.25zm-10.5 0v11.323l4.5-2.25V5.193l-4.5 2.25z"}})])
          )
        }
      }
    